import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getCompaniesCount = (dpsID, companytype) => {
  const queryString = qs.stringify({ companytype });
  return axios.get(
    `/api/dps/${dpsID}/companies/count?${queryString}`
  );
};

export const useCompaniesCount = (dpsID, type, options = {}) => {
  return useQuery(
    `dps-${dpsID}-${type}-count`,
    () => getCompaniesCount(dpsID, type),
    {
      //@ts-ignore
      initialData: { data: { count: 0 } },
      select: ({ data }) => data,
      ...options,
    }
  );
}